//import { SendRequest } from '../wcl-helpers.js';

// wcl_change_avatar

function wcl_change_avatar() {
	if (document.querySelector('.js-change-avatar')) {
		let section = document.querySelector('.js-change-avatar');

		function wclEncodeImgtoBase64(element) {
			let avatar = form.querySelector('.data-wc-img img');
			let img = element.files[0];
			let reader = new FileReader();
			reader.readAsDataURL(img);
			reader.onload = function () {
				console.log('Base64 encoded image:', reader.result);
				avatar.src = reader.result;
			}
		}

		let form = section.querySelector('.js-change-avatar form')

		form.querySelector('input').addEventListener('change', function (event) {
			console.log('File selected:', this.files[0]);
			if (this.files[0].size > 2000000) {
				alert('Image size exceeds 2MB');
				return;
			}
			let file = this.files[0];
			let fileType = file["type"];
			let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
			if (!validImageTypes.includes(fileType)) {
				alert('The image must be in valid formats (gif, jpg, png)');
				return;
			}
			wclEncodeImgtoBase64(this);
		});

		form.addEventListener('submit', function (e) {
			e.preventDefault();
			let form = this;
			let user_avatar = section.querySelector('.js-change-avatar input[name="user_avatar"]').files[0];

			var fd = new FormData();
			fd.append("action", "change_user_avatar");
			fd.append("user_avatar", user_avatar);

			if (form.querySelector('.data-notify')) {
				form.querySelector('.data-notify').remove();
			}

			var xhr = new XMLHttpRequest();
			xhr.open('POST', wcl_obj.ajax_url, true);

			section.querySelector('button[type="submit"]').setAttribute('disabled', 'disabled');

			xhr.onload = function (response) {
				console.log('Server response:', xhr.responseText);
				if (xhr.status >= 200 && xhr.status < 400) {
					var response = JSON.parse(xhr.responseText);
					console.log('Parsed response:', response);

					section.querySelector('button[type="submit"]').removeAttribute('disabled');

					if (response.success == '1') {
						let tag = '<div class="data-notify">' + response.success_message + '</div>';
						form.insertAdjacentHTML('beforeend', tag);
						section.querySelector('.js-change-avatar input[name="user_avatar"]').value = '';
					}
				}
			};
			xhr.send(fd);
		});

		section.querySelector('button[name="cancel"]').addEventListener('click', function (e) {
			e.preventDefault();
			let user_avatar = section.querySelector('.js-change-avatar .data-img').getAttribute('data-val');
			console.log('Cancel button clicked. User avatar:', user_avatar);
			section.querySelector('.js-change-avatar .data-img img').src = user_avatar;
			section.querySelector('.js-change-avatar input[name="user_avatar"]').value = '';
		});
	}
}

// Call the function when the document is ready
document.addEventListener('DOMContentLoaded', function () {
	wcl_change_avatar();
});
